import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { Icon } from '@unite-us/ui';
import React from 'react';
import PropTypes from 'prop-types';
import ToolTip from '../../../common/ToolTip/ToolTip';
import { ProfileViewDetail } from '../../../common/ProfileView/ProfileViewDetail';
var CONTENT_SECOND_PART = 'You may continue with the Pilot enrollment process if there are no errors with the client\'s Medicaid ID, Managed Care or PIHP Enrollment, or Medicaid Plan.';
export var MatchWarning = function MatchWarning(_ref) {
  var _context;
  var label = _ref.label,
    message = _ref.message,
    tooltipMessage = _ref.tooltipMessage;
  return /*#__PURE__*/React.createElement(ProfileViewDetail, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(ToolTip, {
    tooltipContent: _concatInstanceProperty(_context = "".concat(tooltipMessage, " ")).call(_context, CONTENT_SECOND_PART)
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconExclamationCircle",
    className: "fill-current text-dark-blue mr-1"
  })), /*#__PURE__*/React.createElement("p", null, message)));
};
MatchWarning.propTypes = {
  label: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  tooltipMessage: PropTypes.string.isRequired
};
//# sourceMappingURL=MatchWarning.js.map